<template>
  <div class="card">
    <div class="card-body">
      <ListMenu
        :id="`${id}-menu`"
        :item="item"
        :eventBus="eventBus"
        :mobile="true"
        class="card-menu"
      />
      <div class="card-details">
        <div class="card-title">{{ item.name }}</div>
        <div v-if="!!item.is_online" class="card-subtitle">{{ item.enrollment_cost | cost }}</div>
        <div v-else class="card-subtitle">{{ item['length'] }}</div>
        <div class="card-text">
          Brand: {{ item.brand }}
          <br />
          Category: {{ item.category }}
          <br />
          Topic: {{ item.topic }}
          <br />
          Credit Hours: {{ item.hours }}
        </div>
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
import ListCardMixin from "mixins/ListCard";
import ListMenu from "./ListMenu";
export default {
  mixins: [ListCardMixin],
  components: { ListMenu },
};
</script>